import { render, staticRenderFns } from "./AddDocumentFolderDialog.vue?vue&type=template&id=f643fc98&scoped=true"
import script from "./AddDocumentFolderDialog.vue?vue&type=script&lang=js"
export * from "./AddDocumentFolderDialog.vue?vue&type=script&lang=js"
import style0 from "./AddDocumentFolderDialog.vue?vue&type=style&index=0&id=f643fc98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f643fc98",
  null
  
)

export default component.exports